<template>
  <div>
    <v-container>
      <h1 class="primary--text font-weight-bold pb-4">
        {{
          isEditCurrency
            ? $t("settings.currency.updateCurrency")
            : $t("settings.currency.newCurrency")
        }}
      </h1>
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form v-on:submit.prevent="handleSubmit(onSave)" :key="reRender">
          <v-row align="center">
            <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <v-text-field
                outlined
                dense
                readonly
                :label="$t('settings.currency.title')"
                color="secondary"
                v-model="currencyModelObj.currency"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.currency.title')} (${$t('common.en')})`"
                  color="secondary"
                  type="text"
                  v-model="currencyModelObj.nameEn"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.currency.title')} (${$t('common.ar')})`"
                  color="secondary"
                  type="text"
                  v-model="currencyModelObj.nameAr"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <v-text-field
                outlined
                dense
                :label="$t('settings.currency.decimalPlaces')"
                color="secondary"
                v-model="currencyModelObj.decimalPlaces"
              >
              </v-text-field>
            </v-col>
            <!-- <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
                <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.currency.name')} (${$t('common.ar')})`"
                  color="secondary"
                  type="text"
                  v-model="currencyModelObj.nameAr"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col> -->
            <!-- <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
                <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.currency.countryCode')}`"
                  color="secondary"
                  type="text"
                  v-model="currencyModelObj.countryCode"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col> -->
            <!-- <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
                <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.currency.symbol')}`"
                  color="secondary"
                  type="text"
                  v-model="currencyModelObj.symbol"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col> -->
            <!-- <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
                <ValidationProvider v-slot="{ errors }"
                name="regex"
                :rules="{required:true, regex: /^[0-9]{1,3}(?:\.[0-9]{1,3})?$/ }">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.currency.currencyRate')}`"
                  color="secondary"
                  type="text"
                  v-model="currencyModelObj.currencyRate"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col> -->

            <v-col cols="9" sm="9" md="9" class="py-0 mx-auto">
              <div class="d-flex justify-space-around">
                <v-btn
                  width="100%"
                  class="white--text rounded-lg"
                  color="primary"
                  type="submit"
                  :loading="btnLoading"
                >
                  {{ isEditCurrency ? $t("common.update") : $t("common.save") }}
                </v-btn>
              </div>
            </v-col>
            <v-col v-if="isError != null" cols="12" sm="12"
              ><Alert :message="isError" />
            </v-col>
          </v-row>
        </form>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import "@/core/methods/validation_rules";
import { mapGetters } from "vuex";
import { createCurrency } from "../../methods/currency/create_currency";
import { updateCurrency } from "../../methods/currency/update_currency";
export default {
  data() {
    return {
      reRender: 0,
      btnLoading: false,
      currencies: [],

      currencyModelObj: {
        currency: "",
        decimalPlaces: "",
        nameEn: "",
        nameAr: ""
      },
      isError: null
    };
  },
  components: {
    Alert: () => import("@/core/components/Alert.vue")
  },
  mounted() {
    if (this.isEditCurrency)
      this.currencyModelObj = this.$format.cloneVariable(this.editCurrency);
  },
  computed: {
    ...mapGetters(["isEditCurrency", "editCurrency"])
  },

  apollo: {
    getAllCurrency() {
      return {
        query: require("@/settings/api/queries/currency/get_all_currencies.graphql"),
        variables: {
          input: {
            limit: 20,
            skip: 0
          }
        },
        result({ data }) {
          data.getAllCurrency.currencies.forEach(currency => {
            this.currencies.push(currency.currency);
          });
        }
      };
    }
  },
  watch: {
    isEditCurrency: {
      handler() {
        if (this.isEditCurrency) {
          this.currencyModelObj = this.$format.cloneVariable(this.editCurrency);
        } else {
          this.currencyModelObj = {
            currency: "",
            decimalPlaces: "",
            nameEn: "",
            nameAr: ""
          };
          this.reRender++;
        }
      },
      deep: true
    }
  },
  methods: {
    validateName(data) {
      if (data.length === 3) {
        return true;
      } else return "Currency Name Should Be 3 Characters Long";
    },
    async onSave() {
      this.btnLoading = true;
      const input = {
        input: this.$format.cloneVariable(this.currencyModelObj)
      };
      if (!this.isEditCurrency) {
        const CreateInput = {
          input: {
            currency: input.input.currency,
            nameEn: input.input.nameEn,
            nameAr: input.input.nameAr,
          }
        };
        createCurrency(CreateInput).then(response => {
          if (response.data) {
            this.btnLoading = false;
            this.$root.$emit("refetchCurrency");
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.saveSuccess"),
              color: "green"
            });
            this.currencyModelObj = {};
            this.reRender++;
            this.$apollo.queries.getAllCurrency.refetch({
              input: {
                limit: 20,
                skip: 0
              }
            });
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
            setTimeout(() => {
              this.isError = null;
            }, 5000);
          }
        });
      } else {
        const updateInput = {
          id: input.input._id,
          input: {
            currency: input.input.currency,
            decimalPlaces: parseInt(input.input.decimalPlaces),
            nameEn: input.input.nameEn,
            nameAr: input.input.nameAr,
          }
        };
        updateCurrency(updateInput).then(response => {
          if (response.data) {
            this.$root.$emit("refetchCurrency");
            this.btnLoading = false;
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$store.commit("IS_EDIT_CURRENCY", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.updateSuccess"),
              color: "green"
            });
            this.$apollo.queries.getAllCurrency.refetch({
              input: {
                limit: 20,
                skip: 0
              }
            });
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
          }
        });
      }
    },
    onCancel() {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
      this.$store.commit("IS_EDIT_CURRENCY", false);
    }
  }
};
</script>
